<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 1.5C13.724 1.5 13.5 1.724 13.5 2V12.793L2.3535 1.6465C2.1585 1.45125 1.8415 1.45125 1.6465 1.6465C1.45125 1.84175 1.45125 2.15825 1.6465 2.3535L12.793 13.5H2C1.724 13.5 1.5 13.724 1.5 14C1.5 14.276 1.724 14.5 2 14.5H14C14.276 14.5 14.5 14.276 14.5 14V2C14.5 1.724 14.276 1.5 14 1.5Z" fill="#C0C9DA"/>
    </svg>

</template>

<script>
export default {
    name: 'WelcomeHeaderIconArrow',
}
</script>

<style lang="scss" scoped>

</style>
